<script>
	import { Button, Icon } from "svelma";
	import { getOrdinal } from "../utils.js";

	let email = "dbolya@meta.com";

	let startDate = new Date("August 20, 2019 00:0:0 GMT+00:00");
	let today = new Date();

	let elapsedYears = Math.ceil(
		(today.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24 / 365.25
	);
</script>

<div class="box" style="background-image:url('assets/bkg.jpg'); background-size: contain; background-repeat: no-repeat;">
	<article class="media">
		<div class="media-left">
			<figure class="image">
				<img
					src="assets/bioimg2.jpg"
					alt="Daniel Bolya"
					id="bioimg"
					style="width:216px; border-radius:2%; filter: drop-shadow(0px 0px 8px #00000088);"
				/>
			</figure>
			
			<div class="content-to-hide" data-nosnippet style="text-align:left"><br /><br />not for mobile<br /><p style="font-size:10pt">(pls turn phone to side)</p></div>
		</div>
		<div class="media-content">
			<div class="content">
				<h1>Daniel Bolya</h1>
				<p>
					Meta, FAIR<br />
					Research Scientist<br/>
					<a href="mailto:{email}">{email}</a> <br />
				</p>
				<p>
					<a href="https://github.com/dbolya">
						<Button
							><Icon pack="fab" icon="github" /> &nbsp; GitHub
						</Button>
					</a>
					<a
						href="https://scholar.google.com/citations?user=K3ht_ZUAAAAJ&hl=en"
					>
						<Button
							><Icon pack="fas" icon="graduation-cap" /> &nbsp; Scholar
						</Button>
					</a>
					<a href="assets/resume.pdf">
						<Button>
							<Icon pack="fas" icon="file-alt" /> &nbsp; Resume
						</Button>
					</a>
				</p>
				<p style="font-size:12pt">I write papers. Sometimes they're good.</p>
				
			</div>
		</div>
	</article>
</div>

<style>
	.box {
		text-align: right;
		font-size: larger;
	}

	.content-to-hide {
		display: none;
	}

	@media (max-width: 632px) {                  
		.content-to-hide {
			display: block;
		}
	}

	h1 {
		/* color: #ff3e00; */
		/* text-transform: uppercase; */
		font-size: 3em;
		font-weight: 400;
	}
</style>
